var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 29,
    viewBox: "0 0 28 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#65b3a8",
    fillRule: "evenodd",
    d: "M25.2.778H2.8c-1.54 0-2.8 1.26-2.8 2.8v22.4c0 1.54 1.26 2.8 2.8 2.8h22.4c1.54 0 2.8-1.26 2.8-2.8v-22.4c0-1.54-1.26-2.8-2.8-2.8zm-1.4 2.8v4.2H21c-.84 0-1.4.56-1.4 1.4v2.8h4.2v4.2h-4.2v9.8h-4.2v-9.8h-2.8v-4.2h2.8v-3.5c0-2.66 2.24-4.9 4.9-4.9h3.5z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOCIgaGVpZ2h0PSIyOSIgdmlld0JveD0iMCAwIDI4IDI5Ij4KICAgIDxwYXRoIGZpbGw9IiM2NWIzYTgiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTI1LjIuNzc4SDIuOGMtMS41NCAwLTIuOCAxLjI2LTIuOCAyLjh2MjIuNGMwIDEuNTQgMS4yNiAyLjggMi44IDIuOGgyMi40YzEuNTQgMCAyLjgtMS4yNiAyLjgtMi44di0yMi40YzAtMS41NC0xLjI2LTIuOC0yLjgtMi44em0tMS40IDIuOHY0LjJIMjFjLS44NCAwLTEuNC41Ni0xLjQgMS40djIuOGg0LjJ2NC4yaC00LjJ2OS44aC00LjJ2LTkuOGgtMi44di00LjJoMi44di0zLjVjMC0yLjY2IDIuMjQtNC45IDQuOS00LjloMy41eiIvPgo8L3N2Zz4K";
export { SvgFacebook as ReactComponent };